import type { GetDraftQuery, ReleaseByIdQuery } from '@graphql/reactQuery';
import type { editedSplitsSchema } from './edit';
import { initialSplitsErrors } from './errors';
import type { SplitFieldOptionsType } from './fields';
import { SplitsFields, splitsState } from './fields';
import { validateSplits } from './validation';

export const addSplitsRow = (ownerAddress: string) => {
  splitsState.fields.splits.push({
    ownerAddress,
    roles: [],
    percent: '',
  });
};

export const removeSplitsRow = (index: number) => {
  splitsState.fields.splits.splice(index, 1);
};

export const setSplitsFieldAtRowIndex = (
  index: number,
  name: SplitFieldOptionsType,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any,
) => {
  const row = splitsState.fields.splits[index];
  if (!row) return;
  splitsState.fields.splits[index] = { ...row, [name]: value };
  splitsState.touched.splits = true;
};

export const setSplitsTouched = () => {
  splitsState.touched.splits = true;
};

export const clearSplitsErrors = () => {
  splitsState.errors = initialSplitsErrors();
};

export type SplitsDataInfo = NonNullable<NonNullable<GetDraftQuery['draft']['info']>['splitsInfo']>;

export const mapDraftSplitsToFormValues = (data: SplitsDataInfo) => {
  splitsState.fields.splits = data.splits;
  setSplitsTouched();

  validateSplits();
};

export type SplitsReleaseDataInfo = NonNullable<
  NonNullable<ReleaseByIdQuery['release']>['creditSplit']
>['creditAllocations'];

export const mapReleaseSplitsToFormValues = (
  creditAllocations: SplitsReleaseDataInfo,
  publicAddress: string,
) => {
  const splits = creditAllocations
    .map(allocation => ({
      ownerAddress: allocation.owner.publicAddress,
      roles: allocation.roles,
      percent: allocation.percent,
    }))
    .sort(split => (split.ownerAddress === publicAddress ? -1 : 0));
  const parsedSplits = SplitsFields.safeParse({ splits });

  splitsState.fields.splits = parsedSplits.success ? parsedSplits.data.splits : [];

  setSplitsTouched();

  validateSplits();
};

export const mapPersistedSplitsToFormValues = (
  persistedSplits: (typeof editedSplitsSchema)['_input'],
) => {
  splitsState.fields.splits = persistedSplits.splitsInfo?.splits;

  setSplitsTouched();

  validateSplits();
};
